import { Vue, Component, Prop } from 'vue-property-decorator'
import { DropdownMenu, DropdownItem, Toast } from 'vant'
import { allowRefreshOrShare ,inserted , unbind } from '@utils/index'

@Component({
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  }
})
export default class DropDown extends Vue {
  @Prop({ default: '#f6f6f6' }) readonly bgColor!: string
  @Prop({ default: 0 }) readonly position!: number //游标的位置
  @Prop({ default: false }) readonly isloading!: any //加载时 禁止操作
  @Prop({ default: false }) readonly scrollTop!: boolean //是否滑动到顶部，在弹出
  @Prop({ default: 100 }) readonly searchBarAndTabsHeight!: number //距离顶部的top  默认值188/2+6  88（搜索）+100(tab)/2 = 94 再减去6部分手机过于靠近顶部
  isOpen = false

  get marginLeft() {
    const left = 24 + this.position * (160 + 20)
    return left / 75
  }

  open() {
    // 用于在父组件主动控制吸顶
    this.$emit('open-before')
    if (this.isloading) return
    allowRefreshOrShare(false)
    this.isOpen = true
    inserted()
    const img = this.$refs.trip as HTMLImageElement
    img.style.transform = 'rotate(180deg)'
    //为了首页 样式颜色不一样
    const e = this.$refs.container as HTMLElement
    e.style.backgroundColor = '#f6f6f6'
  }
  close() {
    this.isOpen = false
    unbind()
    const img = this.$refs.trip as HTMLImageElement
    img.style.transform = 'rotate(0deg)'
    //为了首页 样式颜色不一样
    const e = this.$refs.container as HTMLElement
    e.style.backgroundColor = this.bgColor
    // 用于在父组件主动控制吸顶
    this.$emit('close-after')
  }

  select(item: any) {
    this.$emit('changevalue', item)
    this.toggle()
  }

  toggle() {
    const dropView: DropdownItem = this.$refs.item as DropdownItem
    dropView.toggle()
  }

  show() {
    //解决兼容性问题
    const a = document.getElementsByClassName('van-dropdown-menu__bar--opened')
    if (a.length > 0) {
      const b = this.$el as HTMLElement
      if (!b.contains(a[0])) {
        return
      }
    }
    if (this.scrollTop) {
      window.scrollTo(0, this.searchBarAndTabsHeight)
    }
    this.toggle()
  }
}
